export const PLATFORM_PACKAGE_BASE_TYPES = [
    'unterkunft',
    'entdecken',
    'angebote',
    'termine',
]

export const PLATFORM_PACKAGE_SOURCE_KINDS = [
    'free',
    'paid',
    'individual',
]

export function centsToEuros(cents) {
    return Number(cents || 0) / 100
}

export function eurosToCents(euros) {
    return Math.round(Number(euros) * 100)
}

export function toDateTimeLocal(value) {
    if (!value) {
        return ''
    }

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) {
        return ''
    }

    const offsetInMilliseconds = date.getTimezoneOffset() * 60 * 1000
    return new Date(date.getTime() - offsetInMilliseconds).toISOString().slice(0, 16)
}

export function platformPackagePayload(formData) {
    return {
        base_type: formData.base_type,
        source_kind: formData.source_kind,
        quantity: Number(formData.quantity),
        price_cents: eurosToCents(formData.price),
        price_per_extra_quantity_cents: eurosToCents(formData.price_per_extra_quantity),
        ends_at: formData.ends_at || null,
    }
}

export function errorMessages(error) {
    return error?.response?.data?.messages || error?.response?.data?.message || error.message
}
